/**
 * 节点参数模板配置
 */

let nodeParamTemplate = {}
nodeParamTemplate.version = '1.0'
nodeParamTemplate.imagePath = 'static/images/workflow/'
nodeParamTemplate['default'] = {
  // 节点类型：Node，CircleNode，LinkNode，TextNode
  nodeType: 'Node',
  // 是否显示阴影, 例如:node.shadow = "true"
  shadow: true,
  // 节点字体，例如：node.font = "12px Consolas"
  font: '16px Consolas',
  // 节点文本位置，例如：node.textPosition = "Bottom_Center"，Middle_Center
  textPosition: 'Bottom_Center',
  // 透明度, 取值范围[0-1]
  alpha: 1,
  // 设置节点的填充颜色
  fillColor: '156,232,164',
  height: 60,
  width: 60,
  // 节点字体
  fontColor: '0,0,0',
}

nodeParamTemplate['circle'] = {
  // 节点类型：Node，CircleNode，LinkNode，TextNode
  nodeType: 'CircleNode',
  fillColor: '13,181,32',
  radius: 30, // 半径
}

nodeParamTemplate['diamond'] = {
  height: 60,
  width: 60,
  // 圆角
  borderRadius: 10,
}
nodeParamTemplate['rectangle'] = {
  height: 60,
  width: 120,
}

/**
 * 节点类型.
 * <pre>
 * 工作流的节点类型通常有：
 * START - 开始
 * TASK_CONFIRM - 确认任务
 * TASK_COMPLEX - 复杂任务
 * TASK_EXECUTE - 自动任务
 * BUSINESS - 子流程
 * FORK_EXCLUSIVE - 排它分支 有两种结束状态的，必须使用排它分支
 * FORK_OR_BEGIN - 分支或开始
 * FORK_OR_END - 分支或结束
 * FORK_AND_BEGIN - 分支与开始
 * FORM_AND_END - 分支与结束
 * FINISH - 完成
 */

nodeParamTemplate['START'] = {
  // 节点类型：Node，CircleNode，LinkNode，TextNode
  // 深绿色：13,181,32
  nodeType: 'Node',
  fillColor: '13,181,32',
  image: nodeParamTemplate.imagePath + 'START.png',
}

nodeParamTemplate['FINISH'] = {
  nodeType: 'Node',
  // fillColor: "255,0,0",
  image: nodeParamTemplate.imagePath + 'FINISH.png',
}

nodeParamTemplate['TASK_CONFIRM'] = {
  nodeType: 'Node',
  // fillColor: "255,0,0",
  image: nodeParamTemplate.imagePath + 'TASK_CONFIRM.png',
}

nodeParamTemplate['TASK_EXECUTE'] = {
  nodeType: 'Node',
  // fillColor: "255,0,0",
  image: nodeParamTemplate.imagePath + 'TASK_EXECUTE.png',
}

nodeParamTemplate['FORK_AND_BEGIN'] = {
  nodeType: 'Node',
  // fillColor: "255,0,0",
  image: nodeParamTemplate.imagePath + 'FORK_AND_BEGIN.png',
}

nodeParamTemplate['FORK_AND_END'] = {
  nodeType: 'Node',
  // fillColor: "255,0,0",
  image: nodeParamTemplate.imagePath + 'FORK_AND_END.png',
}

nodeParamTemplate['FORK_EXCLUSIVE'] = {
  nodeType: 'Node',
  // fillColor: "255,0,0",
  image: nodeParamTemplate.imagePath + 'FORK_EXCLUSIVE.png',
}

nodeParamTemplate['FORK_OR_BEGIN'] = {
  nodeType: 'Node',
  // fillColor: "255,0,0",
  image: nodeParamTemplate.imagePath + 'FORK_OR_BEGIN.png',
}

nodeParamTemplate['FORK_OR_END'] = {
  nodeType: 'Node',
  // fillColor: "255,0,0",
  image: nodeParamTemplate.imagePath + 'FORK_OR_END.png',
}

let linkParamTemplate = {}
linkParamTemplate['default'] = {
  // 线宽
  lineWidth: 1,
  // dashedPattern; // 虚线
  // 箭头大小
  arrowsRadius: 10,
  // 折线拐角处的长度
  bundleOffset: 60,
  // 文本偏移量（向下3个像素）
  textOffsetY: 3,
  // horizontal|vertical
  direction: 'horizontal',
  // 线条之间的间隔
  bundleGap: 20,
  // 节点字体
  fontColor: '0,0,0',
  strokeColor: '0,200,255',
}

export { nodeParamTemplate, linkParamTemplate }
